// extracted by mini-css-extract-plugin
export var copyableField = "_lk-4";
export var customerBadge = "_lk-0";
export var customerInfoTitle = "_lk-2";
export var details = "_lk-1";
export var dropdownContainer = "_lk-5";
export var dropdownImage = "_lk-6";
export var editAssigneeForm = "_lk-a";
export var editButton = "_lk-3";
export var email = "_lk-7";
export var hidden = "_lk-d";
export var input = "_lk-8";
export var saveButton = "_lk-b";
export var shopifyIcon = "_lk-c";
export var suggestionBadge = "_lk-e";
export var suggestionText = "_lk-f";
export var username = "_lk-9";